<template>
  <common-dialog
    ref="dialog"
    ok-text="Confirm"
    :inputs-map="inputs"
    :hasFooter="true"
    :save-cb="changePickUpDate"
    title="Set Pick Up Date"
  />
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
// api
import { modifyShipment } from '@/api/shipment'
// models
import { ShipmentPickUpdateForm } from '@/core/models/shipment'
// message
import PagesMessage from '@/core/message/pages'
export default {
  name: 'SetPickUpDate',
  components: {
    CommonDialog
  },
  props: {
    shipment: {
      type: Object
    }
  },
  data() {
    return {
      inputs: cloneDeep(ShipmentPickUpdateForm),
      portSelected: ''
    }
  },
  computed: {
    shipmentNo() {
      return this.shipment?.no ?? ''
    },
    shipmentId() {
      return this.shipment?.id ?? ''
    }
  },
  methods: {
    open() {
      this.$refs.dialog.open()
      this.inputs[0].value = this.shipmentNo
      this.inputs[1].value = this.shipment?.pickUpDate ?? ''
    },
    changePickUpDate(_, done, error) {
      modifyShipment(this.shipmentId, {
        pickUpDate: this.inputs[1].value
      })
        .then(res => {
          if (res) {
            done()
            this.$message.success('changed successfully')
            PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_DETAIL)
          }
        })
        .catch(err => error(err))
      return [true, '']
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
